import { Component, OnInit } from '@angular/core';
import { LevelOfServiceService } from '../../level-of-service/service/level-of-service.service';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';
import { takeUntil } from 'rxjs/operators';
import { sweetAlert } from 'src/app/utils/swal';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { ChecklistService } from '../checklist-service/checklist.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-add-checklist',
  templateUrl: './add-checklist.component.html',
  styleUrls: ['./add-checklist.component.css']
})
export class AddChecklistComponent implements OnInit {
  checklistForm: UntypedFormGroup;
  spaceTypeList = [];
  checklistId;
  submitted: boolean = false;
  user: any;
  constructor(
    private levelOfServiceService: LevelOfServiceService,
    private fb: UntypedFormBuilder,
    private sharedDataService:SharedDataService,
    private checklistService:ChecklistService,
    private router: Router,
    private activatedRoute:ActivatedRoute
  ) { }

  ngOnInit() {
    this.activatedRoute.params
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe((params) => {
        this.checklistId = params["id"];
        if (this.checklistId) {
          this.getCheckListById();
        }
      });
    this.checklistForm = this.fb.group({
      checklist: this.fb.array([], Validators.required),
      takeSignaturesOnly: [true],
      spaceTypes: [[],Validators.required],
      status:['active',Validators.required]
    })

    this.getUser();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.user = data;
          this.getSpaceTypeList();
        }
      });
  }


  getSpaceTypeList() {
    this.levelOfServiceService
      .getSpaceTypes({ status: 'active' })
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.spaceTypeList = data;
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getCheckListById() {
    this.checklistService.getCheckListById(this.checklistId)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.checklistForm.patchValue({
              status: data.status,
              takeSignaturesOnly: data.takeSignaturesOnly,
              spaceTypes: data.spaceTypes,
            });
            const checklistFormArray = this.listForm;
            checklistFormArray.clear();
            data.checklist.forEach(item => {
              checklistFormArray.push(this.fb.control(item, Validators.required));
            });
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
  }



  onSubmit(){
   this.submitted = true;
    if (this.checklistForm.invalid) {
      return;
    }
    const payload = this.checklistForm.value;
    console.log("Payload check",payload);
    this.checklistService.addCheckList(payload,this.checklistId).pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {  
        if (data) {
          this.router.navigateByUrl("/checklist")
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  toggleSignature() {
    this.checklistForm.patchValue({
      takeSignaturesOnly: !this.form['takeSignaturesOnly'].value
    });
  }


  addChecklist(preCheckList?: string[]) {
    const items = this.listForm as UntypedFormArray;

    if (preCheckList && preCheckList.length) {
      for (const list of preCheckList) {
        items.push(new UntypedFormControl(list, Validators.required));
      }
    } else {
      items.push(new UntypedFormControl('', Validators.required));
    }
  }

  removeCheckList(index: number) {
    this.listForm.removeAt(index);
  }

  get form(){
    return this.checklistForm.controls;
  }

  get listForm() {
    return this.checklistForm.get('checklist') as UntypedFormArray;
  }

  ngOnDestroy(): void {
  }

}
